const DATA_TEST_ID_INHERITED = void 0, DATA_TEST_ID_NOT_NEEDED = void 0;
export {
  DATA_TEST_ID_INHERITED,
  DATA_TEST_ID_NOT_NEEDED
};
//# sourceMappingURL=DATA_TEST_ID_INHERITED.js.map
